export const root = '/dashboard';

export const overview = `${root}/overview`;
export const treasury = `${root}/treasury`;
